import { Divider } from 'primereact/divider';

export default function SelectModule() {
    return (
        <div className="card h-full flex justify-content-center align-items-center">
            <div className="flex justify-content-center align-items-center w-full">
                <img src="assets/layout/images/bien.png" className="app-name flex w-auto h-3rem" alt="Bien" />
                <Divider align="center" type="solid" layout="vertical" />
                <span className="pi pi-phone mr-3 mt-2 text-3xl" aria-hidden="true"></span>
                <h2 className="text-center m-0">0850 532 74 71</h2>
            </div>
        </div>
    );
}
